var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    {
      attrs: { value: _vm.value != "", "escape-close": "" },
      on: {
        input: function ($event) {
          return _vm.onModalInput(false)
        },
      },
    },
    [
      _c(
        "w-card",
        { staticClass: "root" },
        [
          _c(
            "w-card-title",
            [
              _vm._v(" " + _vm._s(_vm.title) + " "),
              _c("w-spacer"),
              _c(
                "w-link",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("common.close"),
                      expression: "$ct('common.close')",
                    },
                  ],
                  attrs: { white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.onModalInput(false)
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "content" }, [
            _c("img", {
              staticClass: "img",
              attrs: { src: _vm.value, alt: "Afbeelding" },
            }),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }